import { faCheckCircle } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import NewModalComponent from "src/core/components/modal/new-modal.component";
import GetConfigTable from "src/core/components/table/get-config-table.component";
import SkeletonComponent from "src/shared/custom-spinner/skeleton.component";
import type {
  GatewayConfigData,
  GatewayConfigParameter,
} from "../../components/types";

type GatewayConfigModalProps = {
  showModal: boolean;
  handleClose: () => void;
  isRestoreMode: boolean;
  isLoading: boolean;
  data: GatewayConfigData | null;
  errorMessage: string | null;
  actionConfig: any[];
  lastSyncDisplay: string;
};

export function GatewayConfigModal({
  showModal,
  handleClose,
  isRestoreMode,
  isLoading,
  data,
  errorMessage,
  actionConfig,
  lastSyncDisplay,
}: GatewayConfigModalProps) {
  return (
    <NewModalComponent
      showModal={showModal}
      handleClose={handleClose}
      headerTitle={
        <div className="gateway-config__header">
          <span className="history-header__icon">
            <FontAwesomeIcon icon={faCheckCircle} />
          </span>

          <div>
            <span className="gateway-config__header-title">
              {isRestoreMode ? "Restore Command" : "Command Results"}
            </span>
            <span className="gateway-config__header-subtitle">
              <span className="gateway-config__header-subtitle-icon">
                &#8635;
              </span>
              Last sync: {lastSyncDisplay}
            </span>
          </div>
        </div>
      }
      actionConfig={actionConfig}
    >
      <div className="gateway-config">
        {isLoading && (
          <SkeletonComponent
            wrapperHeight="320px"
            skeletonHeight="44px"
            isLoading={true}
            count={6}
          >
            <span />
          </SkeletonComponent>
        )}

        {!isLoading && data && (
          <div>
            <p>
              {isRestoreMode
                ? "Restoring the configuraion will revert all current values to the baseline"
                : "The requested configuration paramters have been successfully retrieved from the node."}
            </p>
            <GetConfigTable
              columns={[
                { key: "parameterName", title: "Parameter" },
                {
                  key: "currentValue",
                  title: "Current Value",
                  className: "gateway-config__value--current",
                  render: (parameter: GatewayConfigParameter) =>
                    parameter.currentDisplayValue ??
                    parameter.currentValue ??
                    "--",
                },
                {
                  key: "baselineValue",
                  title: "Baseline Value",
                  className: "gateway-config__value--baseline",
                  render: (parameter: GatewayConfigParameter) =>
                    parameter.baselineDisplayValue ??
                    parameter.baselineValue ??
                    "--",
                },
              ]}
              data={data?.parameters ?? []}
              getRowKey={(parameter: GatewayConfigParameter) =>
                parameter.parameterId
              }
              emptyMessage="No parameters returned from the device."
            />

            {errorMessage && (
              <div className="gateway-config__error">{errorMessage}</div>
            )}
          </div>
        )}
      </div>
    </NewModalComponent>
  );
}
